export default __webpack_public_path__ + "static/media/PaywallCard_man.efe58ee9.png";